import { PURGE } from 'redux-persist'
import orderBy from 'lodash.orderby'
import find from 'lodash.find'
import filter from 'lodash.filter'
import {
  SET_CARD_DEFAULT,
  SET_CARD_TYPING,
  SET_CARD_TYPING_FOCUSED_FIELD,
  SET_CARD_SHOW,
  CLEAN_CARD_DEFAULT,
  CLEAN_CARD_TYPING,
  CLEAN_CARD_SHOW,
  SET_IS_TYPING_CARD,
  SET_IS_SHOWING_CARD,
  SHOW_CARD,
  SET_CARD_LIST,
  ADD_CARD_TO_CARD_LIST,
  REMOVE_CARD_FROM_CARD_LIST,
  SET_PREFERRED_CARD
} from '../actions'

const cardModel = {
  number: '',
  name: '',
  expiry: '',
  cvc: '',
  brand: '',
  token: '',
  isDefault: true,
  maskNumber: '9999 9999 9999 9999',
  cardCVC: {
    name: 'CVC',
    size: 3
  },
  numberLenght: 16
}

const INIT_STATE = {
  isTypingCard: false,
  isShowingCard: false,
  cardDefault: cardModel,
  cardTyping: { ...cardModel, focused: 'number' },
  cardShow: cardModel,
  cardList: []
}

const orderCardListAndFindCardDefault = (cardList) => {
  if (cardList.length > 0) {
    const {
      number, holder, month, year, isDefault
    } = find(cardList, card => card.isDefault)
    let { brand } = find(cardList, card => card.isDefault)

    if (brand === 'Diners') brand = 'dinersclub'
    if (brand === 'Master') brand = 'mastercard'

    const cardDefault = {
      number,
      name: holder,
      expiry: `${month}/${year}`,
      brand,
      isDefault
    }

    cardList = orderBy(cardList, ['isDefault'], ['desc'])

    return { cardList, cardDefault }
  }

  // se não existir mais cartões
  cardList = []
  return { cardList, cardDefault: cardModel }
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_CARD_DEFAULT:
      return { ...state, cardDefault: { ...action.payload } }
    case SET_CARD_TYPING:
      return { ...state, cardTyping: { ...action.payload }, isTypingCard: true }
    case SET_CARD_TYPING_FOCUSED_FIELD:
      return { ...state, cardTyping: { ...state.cardTyping, focused: action.payload } }
    case SET_CARD_SHOW:
      return { ...state, cardShow: { ...action.payload }, isShowingCard: true }
    case CLEAN_CARD_DEFAULT:
      return { ...state, cardDefault: INIT_STATE.cardDefault }
    case CLEAN_CARD_TYPING:
      return { ...state, cardTyping: INIT_STATE.cardTyping, isTypingCard: false }
    case CLEAN_CARD_SHOW:
      return { ...state, cardShow: INIT_STATE.cardShow, isShowingCard: false }
    case SET_IS_TYPING_CARD:
      return { ...state, isTypingCard: action.payload }
    case SET_IS_SHOWING_CARD:
      return { ...state, isShowingCard: action.payload }
    case SHOW_CARD: {
      const cardID = action.payload
      const { cardList } = state

      const {
        number, holder, month, year, isDefault
      } = find(cardList, card => card.cardID === cardID)
      let { brand } = find(cardList, card => card.cardID === cardID)

      if (brand === 'Diners') brand = 'dinersclub'
      if (brand === 'Master') brand = 'mastercard'

      const cardShow = {
        number,
        name: holder,
        expiry: `${month}/${year}`,
        brand,
        isDefault
      }

      return { ...state, cardShow, isShowingCard: true }
    }
    case SET_CARD_LIST: {
      const cardList = action.payload

      const { cardList: cardListOrderly, cardDefault } = orderCardListAndFindCardDefault(cardList)

      return { ...state, cardDefault, cardList: cardListOrderly }
    }
    case SET_PREFERRED_CARD: {
      const cardID = action.payload

      let { cardList } = state
      cardList = cardList.map((card) => {
        if (card.isDefault) card.isDefault = false
        if (card.cardID === cardID) card.isDefault = true
        return card
      })

      const { cardList: cardListOrderly, cardDefault } = orderCardListAndFindCardDefault(cardList)

      return { ...state, cardDefault, cardList: cardListOrderly }
    }
    case ADD_CARD_TO_CARD_LIST: {
      let { cardList } = state
      const newCard = action.payload
      if (newCard.isDefault) {
        cardList = filter(cardList, (card2) => {
          if (card2.isDefault) card2.isDefault = false
          return card2
        })
      }

      cardList.push(newCard)

      const { cardList: cardListOrderly, cardDefault } = orderCardListAndFindCardDefault(cardList)

      return { ...state, cardDefault, cardList: cardListOrderly }
    }
    case REMOVE_CARD_FROM_CARD_LIST: {
      const { cardID, newDefaultCardID } = action.payload
      let { cardList } = state

      const cardRemoved = find(cardList, card => card.cardID === cardID)

      if (cardRemoved.isDefault) {
        cardList = filter(cardList, (card) => {
          if (card.cardID !== cardID) {
            if (card.cardID === newDefaultCardID) {
              card.isDefault = true
            }
            return card
          }
          return false
        })
      } else {
        cardList = filter(cardList, card => card.cardID !== cardID)
      }

      const { cardList: cardListOrderly, cardDefault } = orderCardListAndFindCardDefault(cardList)

      return { ...state, cardDefault, cardList: cardListOrderly }
    }
    case PURGE:
      return INIT_STATE
    default:
      return state
  }
}
